// Module
var code = "<div ng-if=\"!!vm.testApiEndpoint\" class=\"test-api-endpoint-notification\"> <b>{{ vm.testApiEndpoint }}</b><span>API endpoint is used. To change it click 5 times to \"Sign In\" on sign in page.</span> </div> ";
// Exports
module.exports = code;